export default __webpack_public_path__ + "static/media/afb.d1f1f8ea.svg";